const styles = theme => ({
  companySection: {
    display: "flex",
    padding: 32,
    width: "100%",
  },
  companySectionWrapper: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
  },
  companyCardWrapper: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionCard: {
    maxWidth: 300,
    flexGrow: 0,
    flexShrink: 0,
    textAlign: "left",
  },
})
export default styles
